import {inject, Injectable} from "@angular/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ActivatedRouteSnapshot, Router, RoutesRecognized} from "@angular/router";
import {environment} from "src/app/environments/environment";

@Injectable({providedIn: 'root'})
export class FathomService {

  private router = inject(Router);

  constructor() {
    if (!environment.production) return;

    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof RoutesRecognized) {
        const path = this.path(event.state.root, []);
        /*
         * By sending a full URL to fathom, we ensure that
         * the same path sent from any variant of the app
         * (web, Android, or iOS) is represented in the same
         * way on the fathom dashboard.
         *
         * Without this prefix, the same path sent from a
         * different host will result in multiple,
         * indistinguishable entries on the dashboard.
         */
        const url = "https://portal.moovement.co/" + path;
        (window as any).fathom?.trackPageview({ url });
      }
    });
  }

  private path(node: ActivatedRouteSnapshot, segments: Array<string | undefined>): string {
    const path = node.routeConfig?.path;
    if (path) segments.push(path);

    if (node.children && node.children.length > 0) {
      return this.path(node.children[0], segments);
    }

    return segments.join('/');
  }

  trackEvent(name: string) {
    if (!environment.production) return;

    (window as any).fathom?.trackEvent(name);
  }
}
